import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { API_BASE_URL, getApiUrl } from '@/lib/api';
import { authedFetch } from '@/auth/supabase-browser';

const DEV_WORKER_BASE_URL = 'http://localhost:8787';

export function OAuthForwardView() {
  const location = useLocation();

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;
    if (location.pathname === '/api/oauth/google/start') {
      const startUrlPath = '/api/oauth/google/start-url';
      const target = API_BASE_URL
        ? getApiUrl(startUrlPath)
        : `${DEV_WORKER_BASE_URL}${startUrlPath}`;
      void authedFetch(target, { credentials: 'include' })
        .then(async (response) => {
          if (!response.ok) throw new Error(`OAuth start failed: ${response.status}`);
          const body = (await response.json()) as { url?: string };
          if (!body.url) throw new Error('OAuth start URL missing.');
          window.location.assign(body.url);
        })
        .catch(() => {
          const fallback = API_BASE_URL ? getApiUrl(path) : `${DEV_WORKER_BASE_URL}${path}`;
          window.location.replace(fallback);
        });
      return;
    }
    const target = API_BASE_URL ? getApiUrl(path) : `${DEV_WORKER_BASE_URL}${path}`;
    window.location.replace(target);
  }, [location.pathname, location.search]);

  return null;
}
